export const RESOLVE_RELATIONS = [
  "contactSection.form",
  "formContainer.form",
  "videoPlayerButton.configuration",
  "video.configuration",
  "formContainer.form",
  "cardArticle.article",
  "articleHighlightItem.relatedArticle",
  "article.type",
  "article.topic",
  "article.industry",
  "article.region",
  "locationCard.amenities",
];
